import LegacyStory from "%/dynamic-component-editor/entities/story";
import LegacyEpisode from "%/dynamic-component-editor/entities/episode";
import LegacyShow from "%/dynamic-component-editor/entities/show";
import LegacySeason from "%/dynamic-component-editor/entities/season";
import LegacyEvent from "%/dynamic-component-editor/entities/event";
import LegacyComment from "%/dynamic-component-editor/entities/comment";
import LegacyUserProfile from "%/dynamic-component-editor/entities/user-profile";
import LegacyCollectionItems from "%/dynamic-component-editor/entities/collection-items";
import LegacyLoginSignup from "%/dynamic-component-editor/entities/login-signup";
import LegacySubscription from "%/dynamic-component-editor/entities/subscription";
import LegacySubscriptionBillingHistory from "%/dynamic-component-editor/entities/subscription-billing-history";
import LegacyMyPurchasedDigitalProducts from "%/dynamic-component-editor/entities/my-purchased-digital-products";
import LegacyContactUs from "%/dynamic-component-editor/entities/contact-us";
import LegacyDigitalProduct from "%/dynamic-component-editor/entities/digital-product";
import LegacyStoriesWithHashtag from "%/dynamic-component-editor/entities/stories-with-hashtag";
import LegacyExclusiveChatRoom from "%/dynamic-component-editor/entities/exclusive-chat-room";
import LegacyDigitalProductStore from "%/dynamic-component-editor/entities/digital-product-store";
import LegacyChatRoom from "%/dynamic-component-editor/entities/chat-room";
import LegacyEditArticle from "%/dynamic-component-editor/entities/edit-article";
import LegacyPublishedStories from "%/dynamic-component-editor/entities/published-stories";
import LegacyCommentedStories from "%/dynamic-component-editor/entities/commented-stories";
import LegacyUserSettings from "%/dynamic-component-editor/entities/user-settings";
import LegacySubscriptionFailure from "%/dynamic-component-editor/entities/subscription-failure";
import LegacyLovedStories from "%/dynamic-component-editor/entities/loved-stories";
import LegacyApplyToCollaborate from "%/dynamic-component-editor/entities/apply-to-collaborate";
import LegacyCollections from "%/dynamic-component-editor/entities/collections";
import LegacyVotedStories from "%/dynamic-component-editor/entities/voted-stories";
import LegacyCollection from "%/dynamic-component-editor/entities/collection";
import LegacyStoryComment from "%/dynamic-component-editor/entities/story-comment";
import LegacyAffiliateLink from "%/dynamic-component-editor/entities/affiliate-link";
import LegacyFollower from "%/dynamic-component-editor/entities/follower";
import LegacyNewsletter from "%/dynamic-component-editor/entities/newsletter";
import LegacyServicePackage from "%/dynamic-component-editor/entities/service-package";
import LegacySubscriptionPlan from "%/dynamic-component-editor/entities/subscription-plan";
import LegacyUserMessage from "%/dynamic-component-editor/entities/user-message";
import LegacyGeneralEntity from "%/dynamic-component-editor/entities/LegacyGeneralEntity";
import LegacyLayoutEntity from "%/dynamic-component-editor/entities/LegacyLayoutEntity";
import LegacyTextEntity from "%/dynamic-component-editor/entities/LegacyTextEntity";
import LegacyPaymentsEntity from "%/dynamic-component-editor/entities/LegacyPaymentsEntity";

const LEGACY_ENTITIES = {
  "general": LegacyGeneralEntity,
  "layout": LegacyLayoutEntity,
  "text": LegacyTextEntity,
  "payments": LegacyPaymentsEntity,
  "story": LegacyStory,
  "episode": LegacyEpisode,
  "show": LegacyShow,
  "season": LegacySeason,
  "event": LegacyEvent,
  "comment": LegacyComment,
  "userProfile": LegacyUserProfile,
  "collectionItems": LegacyCollectionItems,
  "loginSignup": LegacyLoginSignup,
  "subscription": LegacySubscription,
  "subscriptionBillingHistory": LegacySubscriptionBillingHistory,
  "myPurchasedDigitalProducts": LegacyMyPurchasedDigitalProducts,
  "contactUs": LegacyContactUs,
  "digitalProduct": LegacyDigitalProduct,
  "storiesWithHashtag": LegacyStoriesWithHashtag,
  "exclusiveChatRoom": LegacyExclusiveChatRoom,
  "digitalProductStore": LegacyDigitalProductStore,
  "chatRoom": LegacyChatRoom,
  "editArticle": LegacyEditArticle,
  "publishedStories": LegacyPublishedStories,
  "commentedStories": LegacyCommentedStories,
  "userSettings": LegacyUserSettings,
  "subscriptionFailure": LegacySubscriptionFailure,
  "lovedStories": LegacyLovedStories,
  "applyToCollaborate": LegacyApplyToCollaborate,
  "collections": LegacyCollections,
  "votedStories": LegacyVotedStories,
  "collection": LegacyCollection,
  "storyComment": LegacyStoryComment,
  "affiliateLink": LegacyAffiliateLink,
  "follower": LegacyFollower,
  "newsletter": LegacyNewsletter,
  "servicePackage": LegacyServicePackage,
  "subscriptionPlan": LegacySubscriptionPlan,
  "userMessage": LegacyUserMessage,
};

export default LEGACY_ENTITIES;
